import { FieldData } from "@/components/_Shared/FilterWrapper"

interface UseFilterStorageOptions {
  key: string
}

export const useFilterStorage = (options: UseFilterStorageOptions) => {
  const { key } = options

  const saveFilter = (fieldData: FieldData[]) => {
    sessionStorage.setItem(`${key}-filter`, JSON.stringify(fieldData))
  }

  const saveFilterString = (filterString: string) => {
    sessionStorage.setItem(`${key}-filterString`, filterString)
  }

  const resetFilter = () => {
    sessionStorage.removeItem(`${key}-filter`)
    sessionStorage.removeItem(`${key}-filterString`)
  }

  const getFilter = () => {
    const filter = sessionStorage.getItem(`${key}-filter`)

    return filter ? JSON.parse(filter) : []
  }

  const getFilterString = () => {
    return sessionStorage.getItem(`${key}-filterString`)
  }

  const getUIState = () => {
    const uiState = sessionStorage.getItem(`${key}-uiState`)
    if (uiState === undefined || uiState === null || uiState === "undefined") {
      return null
    }
    return JSON.parse(uiState)
  }

  const saveUIState = (state: Record<string, any>) => {
    sessionStorage.setItem(`${key}-uiState`, JSON.stringify(state))
  }

  return {
    saveFilter,
    saveFilterString,
    resetFilter,
    getFilter,
    getFilterString,
    getUIState,
    saveUIState
  }
}